/**
 * @module cercaliagl/view/VNotification
 */

import { MDCSnackbar } from '@material/snackbar';
import $ from 'jquery';
import BaseView, { EventType } from './BaseView';
import { createIconButton } from './VUtils';

/**
 * @classdesc
 */
class VNotification extends BaseView {
  /**
   * @constructor
   * @param {string} message Message
   * @param {string} severity Severity
   */
  constructor(message, severity) {
    const jqElement = $(`
    <div class="v-notification mdc-snackbar">
      <div class="mdc-snackbar__surface" role="status" aria-relevant="additions">
        <div class="mdc-snackbar__label" aria-atomic="false">
          <span class="icon-alert ${severity}"></span>
          <span class="text">${message}</span>
        </div>
        <div class="mdc-snackbar__actions" aria-atomic="true">
          ${createIconButton('closeBtn', null, 'close')}
        </div>
      </div>
    </div>
    `);
    super(jqElement);

    this.initialize_();
  }

  /**
   * @private
   */
  initialize_() {
    if (!this.jqElement_) {
      return;
    }
    const jqCloseBtn = this.jqElement_.find('.closeBtn');
    if (!jqCloseBtn) {
      return;
    }
    this.on(EventType.ATTACHED, () => {
      const snackbar = new MDCSnackbar(this.jqElement_.get(0));
      snackbar.open();
    });
    jqCloseBtn.on('click', this.destroy.bind(this));
  }

  /**
   * @api
   */
  destroy() {
    this.hide();
    this.jqElement_.remove();
  }
}

export default VNotification;
